import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AutoApplyJobDataQueryVariables = Types.Exact<{
  input: Types.JobDataInput;
  commuteFrom: Types.CommuteLocationInput;
  commuteMethod: Types.CommuteMethod;
  includeCommute: Types.Scalars['Boolean']['input'];
}>;


export type AutoApplyJobDataQuery = { __typename?: 'Query', jobData: { __typename?: 'JobDataPayload', results: Array<{ __typename?: 'JobDataResult', job: { __typename?: 'Job', key: string, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null } | null, employer?: { __typename?: 'Employer', dossier?: { __typename?: 'EmployerDossier', images?: { __typename?: 'ImageBundle', squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null } | null } | null, jobPackagingFeatures?: { __typename?: 'JobPackagingFeatures', brandedJobs: boolean, brandingReasons: Array<Types.FeaturedBrandingReason>, isFeaturedJobCard: boolean } | null, attributes: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, jobTypes: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, shiftAndSchedule: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, jobseekerPreferences?: { __typename?: 'JobseekerPreferences', paySentiment?: Types.JobSeekerSentiment | null } | null, commute?: { __typename?: 'JobCommute', durationMinutes: number } | null } }> } };


export const AutoApplyJobDataDocument = gql`
    query autoApplyJobData($input: JobDataInput!, $commuteFrom: CommuteLocationInput!, $commuteMethod: CommuteMethod!, $includeCommute: Boolean!) {
  jobData(input: $input) {
    results {
      job {
        key
        compensation {
          formattedText
        }
        employer {
          dossier {
            images {
              squareLogoUrls {
                url256
              }
            }
          }
        }
        jobPackagingFeatures {
          brandedJobs
          brandingReasons
          isFeaturedJobCard
        }
        attributes {
          key
          label
        }
        jobTypes: attributes(customClass: "BM62A") {
          key
          label
          sentiment
        }
        shiftAndSchedule: attributes(customClass: "BTSWR") {
          key
          label
          sentiment
        }
        jobseekerPreferences {
          paySentiment
        }
        commute(from: $commuteFrom, method: $commuteMethod) @include(if: $includeCommute) {
          durationMinutes
        }
      }
    }
  }
}
    `;

/**
 * __useAutoApplyJobDataQuery__
 *
 * To run a query within a React component, call `useAutoApplyJobDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoApplyJobDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoApplyJobDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      commuteFrom: // value for 'commuteFrom'
 *      commuteMethod: // value for 'commuteMethod'
 *      includeCommute: // value for 'includeCommute'
 *   },
 * });
 */
export function useAutoApplyJobDataQuery(baseOptions: Apollo.QueryHookOptions<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables> & ({ variables: AutoApplyJobDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>(AutoApplyJobDataDocument, options);
      }
export function useAutoApplyJobDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>(AutoApplyJobDataDocument, options);
        }
export function useAutoApplyJobDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>(AutoApplyJobDataDocument, options);
        }
export type AutoApplyJobDataQueryHookResult = ReturnType<typeof useAutoApplyJobDataQuery>;
export type AutoApplyJobDataLazyQueryHookResult = ReturnType<typeof useAutoApplyJobDataLazyQuery>;
export type AutoApplyJobDataSuspenseQueryHookResult = ReturnType<typeof useAutoApplyJobDataSuspenseQuery>;
export type AutoApplyJobDataQueryResult = Apollo.QueryResult<AutoApplyJobDataQuery, AutoApplyJobDataQueryVariables>;